import React from 'react'
import styles from './VideoPlayer.module.scss'

const VideoPlayer = ({
  url,
  height = '100%',
  width = '100%',
  title = 'video',
}) => (
  <div className={styles.videoWrapper}>
    <iframe
      title={title}
      width={width}
      height={height}
      src={url}
      frameBorder="0"
      allowFullScreen
    />
  </div>
)

export default React.memo(VideoPlayer)
